export enum PassengerType {
  ADULTS = 'ADULTS',
  CHILDREN = 'CHILDREN',
  INFANTS = 'INFANTS'
}

export const FLIGHT_PASSENGER_MAX = 9;

export enum SeatMaxQuantity {
  ADULTS = 5,
  CHILDREN = 0,
  INFANTS = 0
}

export interface PassengerArrangement {
  id: PassengerType;
  quantity: number;
}
